import { Tooltip } from '@mui/material';
import React from 'react';

interface MultilineTooltipProps {
	title: string[];
	children: React.ReactElement;
	placement?: 'bottom' | 'left' | 'right' | 'top';
}

const MultilineTooltip: React.FC<MultilineTooltipProps> = ({ title, children, placement }) => {
	const content = title && title.length > 0 ? title.join('\n') : undefined;

	return content ? (
		<Tooltip title={<div style={{ whiteSpace: 'pre-line', fontSize: '1.2em' }}>{content}</div>} placement={placement}>
			{children}
		</Tooltip>
	) : (
		<>{children}</>
	);
};

export default MultilineTooltip;
